export default {
      id: "ic_copy_header-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_copy_header-usage",
      toString: function () {
        return this.url;
      }
    }